import { render, staticRenderFns } from "./DiplomaEbysSend.vue?vue&type=template&id=0a252cf0"
import script from "./DiplomaEbysSend.vue?vue&type=script&lang=js"
export * from "./DiplomaEbysSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports